import { formatCurrency, formatCurrencyCompact, formatPercent } from '@/utils/format-currency'

export const MASKED_VALUE = '••••'
export const MASKED_DEAL_VALUE = MASKED_VALUE

export function formatDealValue(value: number, visible: boolean, compact = false): string {
  return formatSensitiveCurrency(value, visible, compact)
}

export function formatSensitiveCurrency(value: number, visible: boolean, compact = false): string {
  if (!visible) return MASKED_VALUE
  return compact ? formatCurrencyCompact(value) : formatCurrency(value)
}

export function formatSensitivePercent(value: number, visible: boolean): string {
  if (!visible) return MASKED_VALUE
  return formatPercent(value)
}

export function formatSensitiveCount(value: number, visible: boolean): string {
  if (!visible) return MASKED_VALUE
  return String(value)
}

/** Inicial do closer para avatar fallback */
export function getDealAvatarFallback(closerNome?: string, closerAvatar?: string): string {
  if (closerAvatar?.trim()) return closerAvatar
  const initial = closerNome?.trim()?.[0]
  return initial ? initial.toUpperCase() : '?'
}

/** CNPJ mascarado para exibição (meio oculto) */
export function maskCnpjDisplay(cnpj: string): string {
  const digits = cnpj.replace(/\D/g, '')
  if (digits.length !== 14) return cnpj
  return `**.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-**`
}
